"use client";

import { useEffect, useRef } from "react";
import { webAssetsCdnBaseUrl } from "../../../../shared/constants";

interface VideoProps<T extends string> {
  src: T extends `/${infer _Rest}` ? never : T;
  classOverride?: string;
}

// https://github.com/facebook/react/issues/10389
export default function DescriptionVideo<T extends string>({
  src,
  classOverride = "block max-h-64 rounded-md object-cover w-full",
}: VideoProps<T>) {
  const videoRef = useRef<HTMLVideoElement>(null);

  useEffect(() => {
    if (!videoRef.current) return;
    videoRef.current.defaultMuted = true;
  }, [videoRef]);

  return (
    <div className="order-last col-span-1 block aspect-video w-full sm:order-none">
      <video
        ref={videoRef}
        autoPlay
        loop
        muted
        playsInline
        className={classOverride}
        poster={`${webAssetsCdnBaseUrl}/${src}.png`}
      >
        <source src={`${webAssetsCdnBaseUrl}/${src}-compressed.mp4`} type="video/mp4" />
        <source src={`${webAssetsCdnBaseUrl}/${src}.mp4`} type="video/mp4" />
      </video>
    </div>
  );
}
